import {useIsSoftFeatureToggleActive} from '@aboutyou/feature-flags';

export const useIsWoohooCampaignActive = () => {
  const woohooLogoCampaignLiveMap = {
    LV_LT_EE: useIsSoftFeatureToggleActive('show_woohoo_campaign_LV_LT_EE'),
    FI_BG: useIsSoftFeatureToggleActive('show_woohoo_campaign_FI_BG'),
    HU: useIsSoftFeatureToggleActive('show_woohoo_campaign_HU'),
    DK_SE: useIsSoftFeatureToggleActive('show_woohoo_campaign_DK_SE'),
    RO: useIsSoftFeatureToggleActive('show_woohoo_campaign_RO'),
    IT: useIsSoftFeatureToggleActive('show_woohoo_campaign_IT'),
    NO: useIsSoftFeatureToggleActive('show_woohoo_campaign_NO'),
    BE_NL: useIsSoftFeatureToggleActive('show_woohoo_campaign_BE_NL'),
    DE_AT_CH: useIsSoftFeatureToggleActive('show_woohoo_campaign_DE_AT_CH'),
    ES_PT: useIsSoftFeatureToggleActive('show_woohoo_campaign_ES_PT'),
    CZ: useIsSoftFeatureToggleActive('show_woohoo_campaign_CZ'),
    SI: useIsSoftFeatureToggleActive('show_woohoo_campaign_SI'),
    PL: useIsSoftFeatureToggleActive('show_woohoo_campaign_PL'),
    CY_GR: useIsSoftFeatureToggleActive('show_woohoo_campaign_CY_GR'),
    HR: useIsSoftFeatureToggleActive('show_woohoo_campaign_HR'),
  };

  const isWoohooCampaignActive = Object.values(woohooLogoCampaignLiveMap).some(
    Boolean,
  );

  return isWoohooCampaignActive;
};
